import React from 'react'

import { DateTimePrimitive } from '@teleporthq/react-components'
import { Helmet } from 'react-helmet'

import './home.css'

const Home = (props) => {
  return (
    <div className="home-container1">
      <Helmet>
        <title>Clear Glamorous Dolphin</title>
        <meta property="og:title" content="Clear Glamorous Dolphin" />
        <link
          rel="canonical"
          href="https://clear-glamorous-dolphin-erp1qi.teleporthq.app/"
        />
      </Helmet>
      <span>
        <DateTimePrimitive
          format="DD/MM/YYYY"
          date="Sun Jan 25 2026 16:15:09 GMT+0000 (Greenwich Mean Time)"
        ></DateTimePrimitive>
      </span>
      <div className="home-container2">
        <span>
          This is a test to see if it is accessable from a outside source if you
          can see this that is good!!
        </span>
      </div>
    </div>
  )
}

export default Home
